"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const makeIcon_1 = require("./makeIcon");
const Delete = (props) => ((0, jsx_runtime_1.jsxs)("svg", Object.assign({ width: "16px", height: "16px", viewBox: "0 0 16 16" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M11.558 5.333v8.89H4.447v-8.89h7.11zM10.224 0H5.78l-.889.889H1.78v1.778h12.444V.889h-3.11L10.223 0zm3.112 3.556H2.669v10.666c0 .978.8 1.778 1.778 1.778h7.11c.979 0 1.779-.8 1.779-1.778V3.556z" }, void 0), " "] }), void 0));
exports.DeleteIcon = (0, makeIcon_1.makeIcon)("delete")(Delete);
//# sourceMappingURL=Delete.js.map